import axios from "axios";
import {
  STRAPI_DEV_URL,
  STRAPI_PROD_URL,
} from "../../../services/strapi-content/strapiContent.constants";

export default {
  actions: {
    // Fetch news items from Strapi API using axios
    async fetchSiteNofitications(context, payload) {
      const environment =
        process.env.VUE_APP_ENV === "development"
          ? STRAPI_DEV_URL
          : STRAPI_PROD_URL;

      try {
        const response = await axios.get(`${environment}${payload.link}`);
        return response;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
